var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFormMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_525_18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.95432 31.0457 0 20 0C8.9543 0 0 8.95432 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#EDF0F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1418 7.9248H24.8583C25.8342 7.9248 26.6197 8.71584 26.6197 9.69836V30.301C26.6197 31.2835 25.8342 32.0745 24.8583 32.0745H15.1418C14.166 32.0745 13.3804 31.2835 13.3804 30.301V9.69836C13.3804 8.71584 14.166 7.9248 15.1418 7.9248Z",
    stroke: "black",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3804 26.4062V30.3001C13.3804 31.2827 14.166 32.0746 15.1418 32.0746H24.8578C25.8336 32.0746 26.6192 31.2827 26.6192 30.3001V26.4062H13.3804Z",
    stroke: "black",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1191 29.2412H20.8812",
    stroke: "black",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2295 13.834H19.6723",
    stroke: "black",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2295 16.9805H22.7708",
    stroke: "black",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2295 20.127H22.7708",
    stroke: "black",
    strokeWidth: 1.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_525_18"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFormMenu);
export default __webpack_public_path__ + "static/media/icon_form_menu.ffa7c2add67c9b26f2b5b1b5226fc337.svg";
export { ForwardRef as ReactComponent };